import { Assets } from '../common/Assets';

export const CoverPage = {
  Body: `
        <div id="page_1">
            <div id="pageHeader">
                <img src="${Assets.MassMutual_Logo}" alt="" width="300px" style="padding-left:220px;">
            </div>
            <div class="dclr"></div>
            <div id="id_1">
                <p class="p0 ft0">MassMutual Whole Life {{PRODUCT}}</p>
                <p class="p1 ft1">{{SUB_HEADER}}</p>
                <p class="p2 ft2">Prepared for:</p>
                <p class="p3 ft3">{{ClientFirstName}} {{ClientLastName}}</p>
                <p class="p3 ft3">{{ClientGender}}, Age {{ClientAge}}</p>
                <p class="p4 ft2">Presented by:</p>
                <p class="p3 ft3">{{AgentFirstName}} {{AgentLastName}}</p>
                <p class="p3 ft3">{{AgentAddressLine1}}</p>
                <p class="p3 ft3">{{AgentCity}}, {{AgentState}} {{AgentZipCode}}</p>
                {{AgentLicenseNumber}}
                {{AgentPhoneNumber}}
                <p class="p5 ft3">{{CurrentDate}}</p>
                <p class="p6 ft2">CRN: {{CRNValue}}</p>
            </div>

            {{BankSaleDisclosure}}

            <div id="pageFooter">
                <p class="p7 ft4">©{{CopyrightYear}} Massachusetts Mutual Life Insurance Company (MassMutual), Springfield, MA 01111-0001.<BR/>
                All rights reserved. www.massmutual.com.
                <br><p class="p7 ft5">{{TotalTargetPremium}}</p></p>
                <div class="pagenumbers">
                    <p class="p-pagenumbers">Page {{page}} of {{pages}}</p>
                </div>
            </div>
        </div>
    `,
  Styles: `
        body {margin-top: 0px;margin-left: 0px;}

        #page_1 {position:relative; overflow: hidden;margin: 16px 0px 10px 16px;padding: 0px;border: none;width: 790px;}
        #page_1 #id_1 {border:none;margin: 80px 0px 0px 24px;padding: 0px;border:none;width: 766px;overflow: hidden;}
        #page_1 #id_2 {border:none;margin: 72px 0px 0px 667px;padding: 0px;border:none;width: 123px;overflow: hidden;}

        #page_1 #p1dimg1 {top:0px;left:200px;z-index:-1;}

        #page_1 #bank-sale-disclosure {text-align: center; border: 1px solid black; padding: 0px; margin-top: 160px; width: 540px;}

        #page_1 #bank-sale-disclosure-with-agent-license {text-align: center; border: 1px solid black; padding: 0px; margin-top: 150px; width: 540px;}

        .dclr {clear:both;float:none;height:1px;margin:0px;padding:0px;overflow:hidden;}

        .ft0{font: bold 24px 'Arial Narrow';color: #0b2f6c;line-height: 17px;}
        .ft1{font: 18px 'Arial Narrow';color: #0b2f6c;line-height: 17px;}
        .ft2{font: bold 12px 'Arial Narrow';line-height: 15px;}
        .ft3{font: 12px 'Arial Narrow';}
        .ft4{font: 10px 'Arial Narrow';}
        .ft5{font: 9px 'Arial Narrow';font-weight: bold}

        .p0{text-align: left;padding-left: 15px;margin-top: 0px;margin-bottom: 0px;}
        .p1{text-align: left;padding-left: 15px;margin-top: 8px;margin-bottom: 0px;}
        .p2{text-align: left;padding-left: 15px;margin-top: 29px;margin-bottom: 0px;}
        .p3{text-align: left;padding-left: 15px;margin-top: 0px;margin-bottom: 0px;}
        .p4{text-align: left;padding-left: 15px;margin-top: 32px;margin-bottom: 0px;}
        .p5{text-align: left;padding-left: 15px;margin-top: 14px;margin-bottom: 0px;}
        .p6{text-align: left;padding-left: 15px;margin-top: 13px;margin-bottom: 32px;}
        .p7{text-align: left;padding-left: 15px;margin-top: 0px;}

        .disclaimer {text-align: left;padding-left: 15px;margin: 16px 0 16px 0; max-width: 500px;}`,
  BankSaleDisclosure: `
        <div id="bank-sale-disclosure">
            <p class="ft2">
                NOT A BANK OR CREDIT UNION DEPOSIT OR OBLIGATION • NOT FDIC OR NCUA INSURED • NOT INSURED BY ANY FEDERAL GOVERNMENT AGENCY • NOT GUARANTEED BY ANY BANK OR CREDIT UNION
            </p>
        </div>`,
  BankSaleDisclosureWithAgentLicense: `
        <div id="bank-sale-disclosure-with-agent-license">
            <p class="ft2">
                NOT A BANK OR CREDIT UNION DEPOSIT OR OBLIGATION • NOT FDIC OR NCUA INSURED • NOT INSURED BY ANY FEDERAL GOVERNMENT AGENCY • NOT GUARANTEED BY ANY BANK OR CREDIT UNION
            </p>
        </div>`,
  LowerDividendProductionLabel: `
        <TR>
        <TD colspan=2><P class="p-center sub-heading-center">This illustration was produced using a hypothetical lower dividend schedule.</P></TD>
        </TR>
        `,
};
